module.exports = __webpack_public_path__ + "static/media/7.6cee0d4e.jpg";